import React from "react";
import { useSelector } from "react-redux";
import { Box, Flex, Text } from "rebass";
import { MdNavigateBefore } from "react-icons/md";

import { ROOT_FOLDER } from "../../../store/modules/library/constants";
import {
  getActiveFolderParent,
  getActiveFolderTitle,
} from "../../../store/modules/library/selectors";

// import { SearchBar } from "../SearchBar";
import { UserSettings } from "../UserSettings";
import { Link } from "../styled/Link";
import { AddRecordButton } from "../AddRecord/Button";

export const Header: React.FC = () => {
  const title = useSelector(getActiveFolderTitle);
  const parent = useSelector(getActiveFolderParent);

  return (
    <Box p="30px 17px 10px">
      <Flex alignItems="center">
        {
          parent && (
            <Link to={parent !== ROOT_FOLDER ? `/folder/${parent}` : "/"}>
              <MdNavigateBefore size={33} display="block" />
            </Link>
          )
        }

        <Text
          flex={1}
          fontSize="28px"
          fontWeight="bold"
          css="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        >
          {title ? title : "Library"}
        </Text>

        <AddRecordButton />

        <UserSettings />
      </Flex>

      {/*<Box mt="16px">
        <SearchBar />
      </Box>*/}
    </Box>
  );
};
